import { useNavigate, useLocation } from "react-router-dom"
import {
    Home,
    Users,
    UserCheck,
    BookOpen,
    CreditCard,
    MessageSquare,
    Video,
    LogOut,
    Tag,
    FolderTree,
    UserPlus,
    HelpCircle,
    Mail,
    Star
} from "lucide-react"

export default function AdminSidebar() {
  const navigate = useNavigate()
  const location = useLocation()

  const sidebarItems = [
    { id: "dashboard", label: "Dashboard", icon: Home, link: "/admin/dashboard" },
    { id: "users", label: "Gestion des étudiants", icon: Users, link: "/admin/users" },
    { id: "admins", label: "Gestion des admins", icon: UserCheck, link: "/admin/admins" },
    { id: "courses", label: "Gestion des cours", icon: BookOpen, link: "/admin/courses" },
    { id: "course-enrollments", label: "Utilisateurs de cours", icon: UserPlus, link: "/admin/course-enrollments" },
    { id: "categories", label: "Catégories", icon: FolderTree, link: "/admin/categories" },
    { id: "promo-codes", label: "Codes promo", icon: Tag, link: "/admin/promo-codes" },
    { id: "webinars", label: "Gestion des webinaires", icon: Video, link: "/admin/webinars" },
    { id: "faqs", label: "Gestion des FAQs", icon: HelpCircle, link: "/admin/faqs" },
    { id: "newsletter-subscribers", label: "Abonnés newsletter", icon: Mail, link: "/admin/newsletter/subscribers" },
    { id: "newsletter-campaigns", label: "Campagnes newsletter", icon: Mail, link: "/admin/newsletter/campaigns" },
    { id: "comments", label: "Commentaires", icon: MessageSquare, link: "/admin/comments" },
    { id: "testimonials", label: "Témoignages", icon: Star, link: "/admin/testimonials" },
    { id: "payments", label: "Paiements", icon: CreditCard, link: "/admin/payments" }
  ]

  const handleNavigation = (item) => {
    if (item.link) {
      navigate(item.link)
    }
  }

  const handleLogout = () => {
    console.log("Logout")
    // Ici tu ferais la logique de déconnexion
  }

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-white shadow-lg flex flex-col z-40">
      {/* Header fixe avec le même logo que la navbar */}
      <div className="flex items-center p-6 pb-4 flex-shrink-0 border-b border-gray-100 cursor-pointer" onClick={() => navigate('/')}>
        <img
          src="/images/logo.png"
          alt="AY Solutions Academy"
          className="h-14 w-auto object-contain"
        />
      </div>

      {/* Navigation scrollable */}
      <nav className="flex-1 overflow-y-auto px-6 py-4 space-y-2">
        {sidebarItems.map((item) => {
          const Icon = item.icon
          // Pour certaines routes, considérer actif si on est sur la route ou ses sous-routes
          let isActive = false
          if (item.id === 'courses') {
            isActive = location.pathname.startsWith('/admin/courses') && !location.pathname.startsWith('/admin/course-enrollments')
          } else if (item.id === 'course-enrollments') {
            isActive = location.pathname.startsWith('/admin/course-enrollments')
          } else if (item.id === 'categories') {
            isActive = location.pathname.startsWith('/admin/categories')
          } else if (item.id === 'promo-codes') {
            isActive = location.pathname.startsWith('/admin/promo-codes')
          } else if (item.id === 'comments') {
            isActive = location.pathname.startsWith('/admin/comments')
          } else if (item.id === 'webinars') {
            isActive = location.pathname.startsWith('/admin/webinars')
          } else if (item.id === 'faqs') {
            isActive = location.pathname.startsWith('/admin/faqs')
          } else if (item.id === 'newsletter-subscribers' || item.id === 'newsletter-campaigns') {
            isActive = location.pathname.startsWith('/admin/newsletter')
          } else {
            isActive = location.pathname === item.link
          }
          
          return (
            <button
              key={item.id}
              onClick={() => handleNavigation(item)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors ${
                isActive
                  ? 'bg-[#203a8a] text-white'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </button>
          )
        })}
      </nav>

      {/* Logout fixe en bas */}
      <div className="p-6 pt-4 flex-shrink-0 border-t border-gray-100">
        <button
          onClick={handleLogout}
          className="flex items-center space-x-3 p-3 rounded-lg w-full text-left text-gray-600 hover:bg-gray-100 transition-colors"
        >
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  )
}